import { createWebSocketStore } from 'src/components/#services/helpers';
import { isLoggedIn } from 'src/services/auth';
export const getMyWallet = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'wallet_getMy',
        agent: 'near-adapter',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const buyWallet = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'wallet_buy',
        agent: 'near-adapter',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
isLoggedIn.subscribe(() => {
    getMyWallet.reset();
});
